<template>
  <div v-if="plate">
    <v-checkbox
      :label="`${lead.firstname}, If you passed away early what are the MAIN things you need to take care of?`"
      v-model="plate.isAgreeWithMainNeed"
      :error="$v.plate.isAgreeWithMainNeed.$error"
    />

    <div class="questions-inner">
      <div v-for="(type, k) in Object.keys(needs)" :key="k">
        <v-checkbox
          :label="needs[type].label"
          v-model="needs[type].isSelected"
          @change="onProtectionTypeChange(type)"
        />
      </div>
    </div>

    <v-checkbox
      label="And who's going to be your Beneficiary?"
      v-model="plate.isAgreeWithBeneficiary"
      :error="$v.plate.isAgreeWithBeneficiary.$error"
    />

    <v-btn-toggle
      v-model="currentBeneficiary.relationship"
      class="my-2"
      :class="{ 'toggle-error': $v.currentBeneficiary.relationship.$error }"
    >
      <v-btn value="child">Child</v-btn>
      <v-btn value="spouse">Spouse</v-btn>
      <v-btn value="other">Other</v-btn>
    </v-btn-toggle>

    <v-checkbox
      :label="`You need to make sure
      ${protections} is taken care of for your
      ${currentBeneficiary.relationship}, so they can survive and live comfortable, 
      what's their name?`"
      v-model="plate.isHasMoney"
      :error="$v.plate.isHasMoney.$error"
    />

    <v-text-field
      label="Beneficiary name:"
      class='input-small'
      v-model="currentBeneficiary.name"
      :error="$v.currentBeneficiary.name.$error"
    />

    <v-checkbox
      :label="`Perfect, I'll make sure ${currentBeneficiary.name} has money for ${protections}`"
      v-model="plate.isTakeCare"
      :error="$v.plate.isTakeCare.$error"
    />

    <v-checkbox
      :label="`Is ${currentBeneficiary.name}:`"
      v-model="plate.isReplacementAsked"
      :error="$v.plate.isReplacementAsked.$error"
    />

    <v-btn-toggle
      v-model="currentBeneficiary.status"
      class="my-2"
      :class="{ 'toggle-error': $v.currentBeneficiary.status.$error }"
    >
      <v-btn value="Working">Working</v-btn>
      <v-btn value="Home maker">Home maker</v-btn>
      <v-btn value="Disabled">Disabled</v-btn>
      <v-btn value="Retired">Retired</v-btn>
    </v-btn-toggle>

    <!--  family   -->

    <template v-if="family.isSelected">
      <v-checkbox
        label="I understand you need to take care of Family protection:"
        v-model="family.isAgree"
        :error="$v.family.isAgree.$error"
      />

      <div class="questions-inner">
        <v-checkbox
          label="Would like to take care of income replacement?"
          v-model="family.isTakeCare"
          :error="$v.family.isTakeCare.$error"
        />

        <v-btn-toggle v-model="family.replacement" class="my-2">
          <v-btn value="will">Yes</v-btn>
          <v-btn value="won't">No</v-btn>
        </v-btn-toggle>

        <v-checkbox
          :label="`Excellent ${lead.firstname}, to protect the family we ${family.replacement} need to replace your income. Do you have any children?`"
          v-model="family.isReplaceIncome"
          :error="$v.family.isReplaceIncome.$error"
        />

        <v-btn-toggle v-model="family.isAnyChildren" class="my-2">
          <v-btn :value="true">Yes</v-btn>
          <v-btn :value="false">No</v-btn>
        </v-btn-toggle>

        <div v-if="family.isAnyChildren">
          <v-checkbox
            label="That's perfect! How many children do you have?"
            v-model="family.isChildrenCountAsked"
            :error="$v.family.isChildrenCountAsked.$error"
          />

          <v-btn-toggle
            v-model="family.childrenCount"
            class="my-2"
            :class="{ 'toggle-error': $v.family.childrenCount.$error }"
          >
            <v-btn
              v-for="(item, k) in childrenCount"
              :key="k"
              :value="item.value"
            >
              {{ item.placeholder }}
            </v-btn>
          </v-btn-toggle>

          <v-checkbox
            label="You must be proud, how old is your youngest?"
            v-model="family.isAgeOfChildAsked"
            :error="$v.family.isAgeOfChildAsked.$error"
          />

          <v-text-field
            type="number"
            placeholder="Age of youngest child"
            suffix="years old"
            class="number-input input-small"
            v-model="family.childrenAge"
            :error="$v.family.childrenAge.$error"
          />

          <v-checkbox
            label="Do you need to make sure college expenses are paid for?"
            v-model="family.isCollegeExpensesAsked"
            :error="$v.family.isCollegeExpensesAsked.$error"
          />

          <v-btn-toggle v-model="family.collegeExpenses" class="my-2">
            <v-btn :value="true">Yes</v-btn>
            <v-btn :value="false">No</v-btn>
          </v-btn-toggle>
        </div>
      </div>
    </template>

    <!--  mortgage  -->

    <template v-if="mortgage.isSelected">
      <v-checkbox
        label="You mentioned you need to take of the Mortgage:"
        v-model="mortgage.isAgree"
        :error="$v.mortgage.isAgree.$error"
      />

      <div class="questions-inner">
        <v-checkbox
          label="How much money do you need to pay off your home?"
          v-model="mortgage.isHomePayoffAsked"
          :error="$v.mortgage.isHomePayoffAsked.$error"
        />

        <v-text-field
          label="Amount left of house"
          v-mask="'$##################'"
          class="input-small"
          v-model="mortgage.amount"
          :error="$v.mortgage.amount.$error"
        />

        <v-checkbox
          label="It's import to take care of the home. How many years are left on your mortgage"
          v-model="mortgage.isMortgageYearsLeftAsked"
          :error="$v.mortgage.isMortgageYearsLeftAsked.$error"
        />

        <v-text-field
          label="Amount of years left on house"
          suffix="Years"
          class="input-small"
          v-model="mortgage.yearsLeft"
          :error="$v.mortgage.yearsLeft.$error"
        />
      </div>
    </template>

    <!--  debt   -->

    <template v-if="debt.isSelected">
      <v-checkbox
        label="I understand you need to  take care of Debt protection:"
        v-model="debt.isAgree"
        :error="$v.debt.isAgree.$error"
      />

      <div class="questions-inner">
        <v-checkbox
          label="How much money do you need  to pay off outstanding debts? "
          v-model="debt.isDebtsAmountAsked"
          :error="$v.debt.isDebtsAmountAsked.$error"
        />

        <v-text-field
          label="Amount of debt"
          v-mask="'$##################'"
          class="input-small"
          v-model="debt.amount"
          :error="$v.debt.amount.$error"
        />
      </div>
    </template>

    <!--  final expenses   -->

    <template v-if="finalExpenses.isSelected">
      <v-checkbox
        v-model="finalExpenses.isAgree"
        :error="$v.finalExpenses.isAgree.$error"
        label="Ok, I understand we Need to take care of the final expenses. Are you thinking:"
      />

      <div class="questions-inner">
        <v-btn-toggle
          v-model="finalExpenses.target"
          @change="onNeedsDetailsChange"
          class="my-2"
          :class="{ 'toggle-error': $v.finalExpenses.target.$error }"
        >
          <v-btn value="Cremation">Cremation</v-btn>
          <v-btn value="Casket">Casket</v-btn>
        </v-btn-toggle>

        <v-checkbox
          :error="$v.finalExpenses.isAgreeWithAmount.$error"
          :label="`Got it, you need Life Insurance to take care of the 
          ${finalExpenses.target} it's going to be between:`"
          v-model="finalExpenses.isAgreeWithAmount"
        />

        <div v-if="finalExpenses.amount">
          {{ finalExpenses.amount }}
        </div>
      </div>
    </template>

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps, ProtectionTypes } from '@/common/variables';
import { isChecked, isRequired } from '@/common/helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'AnalysisPlate',
  components: { PlateFooter },
  props: {
    lead: Object,
    beneficiary: Object,
  },
  data: () => ({
    plate: null,
    isLoading: false,
    selectedProtections: [],
    currentBeneficiary: {},

    childrenCount: [
      { placeholder: 1, value: 1 },
      { placeholder: 2, value: 2 },
      { placeholder: '3+', value: '3+' },
    ],
  }),
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.analysis
    );
    this.plate = data;
    this.currentBeneficiary = { ...this.beneficiary };
  },
  computed: {
    ...mapGetters({ needs: 'plates/needs' }),
    protections() {
      return this.selectedProtections
        .map((i) => i.label)
        .toString()
        .replaceAll(',', ', ');
    },
    debt() {
      return this.needs[ProtectionTypes.debt];
    },
    finalExpenses() {
      return this.needs[ProtectionTypes.finalExpenses];
    },
    mortgage() {
      return this.needs[ProtectionTypes.mortgage];
    },
    family() {
      return this.needs[ProtectionTypes.family];
    },
  },
  methods: {
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.occupation);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setBeneficiary', this.currentBeneficiary);
      this.$store.commit('plates/setStep', PlatesSteps.needs);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
    onNeedsDetailsChange(val) {
      return (this.finalExpenses.amount =
        val === 'Cremation' ? '3-5K' : '8-10K');
    },
    onProtectionTypeChange(type) {
      const needByType = this.needs[type];

      this.selectedProtections = needByType.isSelected
        ? [...this.selectedProtections, needByType]
        : this.selectedProtections.filter((i) => i.type !== type);
    },

    //validation rules
    mortgageFieldChecked(val) {
      return this.mortgage.isSelected ? isChecked(val) : true;
    },
    mortgageFieldRequired(val) {
      return this.mortgage.isSelected ? isRequired(val) : true;
    },
    debtFieldChecked(val) {
      return this.debt.isSelected ? isChecked(val) : true;
    },
    debtFieldRequired(val) {
      return this.debt.isSelected ? isRequired(val) : true;
    },
    familyFieldChecked(val) {
      return this.family.isSelected ? isChecked(val) : true;
    },
    familyChildrenFieldChecked(val) {
      if (this.family.isAnyChildren && this.family.isSelected) {
        return isChecked(val);
      }
      return true;
    },
    familyChildrenFieldRequired(val) {
      if (this.family.isAnyChildren && this.family.isSelected) {
        return isRequired(val);
      }
      return true;
    },
    feFieldChecked(val) {
      return this.finalExpenses.isSelected ? isChecked(val) : true;
    },
    feFieldRequired(val) {
      return this.finalExpenses.isSelected ? isRequired(val) : true;
    },
  },

  validations() {
    return {
      plate: {
        isAgreeWithMainNeed: { checked: isChecked },
        isHasMoney: { checked: isChecked },
        isTakeCare: { checked: isChecked },
        isAgreeWithBeneficiary: { checked: isChecked },
        isReplacementAsked: { checked: isChecked },
      },

      currentBeneficiary: {
        relationship: { required },
        name: { required },
        status: { required },
      },

      debt: {
        isAgree: { checked: this.debtFieldChecked },
        isDebtsAmountAsked: { checked: this.debtFieldChecked },
        amount: { required: this.debtFieldRequired },
      },

      finalExpenses: {
        isAgree: { checked: this.feFieldChecked },
        target: { required: this.feFieldRequired },
        isAgreeWithAmount: { checked: this.feFieldChecked },
      },

      mortgage: {
        isAgree: { checked: this.mortgageFieldChecked },
        isHomePayoffAsked: { checked: this.mortgageFieldChecked },
        isMortgageYearsLeftAsked: { checked: this.mortgageFieldChecked },
        yearsLeft: { required: this.mortgageFieldRequired },
        amount: { required: this.mortgageFieldRequired },
      },

      family: {
        isAgree: { checked: this.familyFieldChecked },
        isTakeCare: { checked: this.familyFieldChecked },
        isReplaceIncome: { checked: this.familyFieldChecked },
        isChildrenCountAsked: { checked: this.familyChildrenFieldChecked },
        childrenCount: { required: this.familyChildrenFieldRequired },
        isAgeOfChildAsked: { checked: this.familyChildrenFieldChecked },
        childrenAge: { required: this.familyChildrenFieldRequired },
        isCollegeExpensesAsked: { checked: this.familyChildrenFieldChecked },
      },
    };
  },
};
</script>

<style scoped lang="scss">
.questions-inner {
  margin-left: 60px;
}

.number-input {
  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.toggle-error button {
  color: #ff5252 !important;
  border-color: #ff5252 !important;
}

.input-small {
  max-width: 280px;
}
</style>